import {Component} from 'react';
import L from 'leaflet';

export default class LeafletIcons extends Component {
  constructor(props) {
    super(props);
    this.wideGreenIcon = this.commonPin('location-icon-green-question.png');
    this.thinGreenIcon = this.commonPin("location-icon-green-small.png");
    this.mapIcon = [
      [this.thinGreenIcon, this.wideGreenIcon],
      [this.commonPin('location-icon-yellow-small.png'), this.commonPin('location-icon-yellow-question.png')],
      [this.commonPin('location-icon-red-small.png'), this.commonPin('location-icon-red-question.png')]
    ];
  }

  async componentDidMount() {
    this.wideGreenIcon = this.commonPin('marker-icon3.png');
    this.thinGreenIcon = this.commonPin("marker-icon-g.png")
  }

  commonPin (iconName) {
    return L.icon( {iconUrl: iconName,
      shadowUrl: 'marker-shadow.png',
      iconSize:     [25, 41], 
      shadowSize:   [41, 41],
      iconAnchor:   [12, 41], // point of the icon which will correspond to marker's location
      shadowAnchor: [12, 41],
      popupAnchor:  [1, -34] // point from which the popup should open relative to the iconAnchor
    });
  }
  
  // precise location = accuracy 0, contact 0 green, 2 red
  fromAttributes(contact, accuracy) {
    return this.mapIcon[contact][accuracy];
  }
  render() {
    return null;
  }
}